import Sidebar from 'components/global/sidebar'
import Navbar from 'components/user/navbar'
import React from 'react'

const Layout = ({children}) => {
    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                {children}
            </div>
        </div>
    )
}

export default Layout